@if (isPS) {
  <button
    disabled
    mat-stroked-button
    [ngClass]="{ 'ps-status': isPS }"
    data-translation-key="horse_info_ps"
  >
    {{ 'horse_info.ps' | translate }}
  </button>
}
@if (isSold) {
  <button
    disabled
    mat-stroked-button
    [ngClass]="{ 'sold-status': isSold }"
    data-translation-key="horse_info_sold"
    >
    {{ 'horse_info.sold' | translate }}
  </button>
}
@if (isRna) {
  <button
    disabled
    mat-stroked-button
    [ngClass]="{ 'rna-status': isRna }"
    data-translation-key="horse_info_rna"
  >
    {{ 'horse_info.rna' | translate }}
  </button>
}
@if (isWinner) {
  <button
    disabled
    mat-stroked-button
    [ngClass]="{ 'winner-status': isWinner }"
    data-translation-key="horse_info_winner"
    >
    {{ 'horse_info.winner' | translate }}
  </button>
}
@if (isUnSold) {
  <button
    disabled
    mat-stroked-button
    [ngClass]="{ 'unsold-status': isUnSold }"
    data-translation-key="horse_info_unsold"
    >
    {{ 'horse_info.unsold' | translate }}
  </button>
}
@if (isWithdrawn) {
  <button
    disabled
    mat-stroked-button
    [ngClass]="{ 'withdrawn-status': isWithdrawn }"
    data-translation-key="horse_info_withdrawn"
  >
    {{ 'horse_info.withdrawn' | translate }}
  </button>
}
<!-- <button
disabled
mat-stroked-button
[ngClass]="{ 'sold-status': isReserved }"
*ngIf="isReserved"
[attr.data-translation-key]="('reserved' | translate)?.translationsKey"
>
{{ ('reserved' | translate)?.value }}
</button> -->
